/* eslint-disable */
/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken, AxiosError } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';

export interface ExceptionResponse {
    Error?: any;
    [key: string]: any;
}

export const makeCodedException = async <T>(request: AxiosPromise<T>) => {
    try {
        return await request;
    } catch (e) {
        const error = e as AxiosError<ExceptionResponse | string>;
        if (error.response && typeof error.response.data !== 'string') {
            // enforce ExceptionResponse structure onto error.response.data
            error.response.data = error.response.data || {};
            error.response.data.Error = error.response.data.Error || {};
        }
        return Promise.reject(error);
    }
};

export interface IJobAssistApi {
    getBattlecardV3(
        tenantId: string,
        userId: string,
        query: GetBattlecardV3Params,
        cancelToken?: CancelToken,
    ): AxiosPromise<BattlecardV3Response | undefined>;
    getTechnician(
        tenantId: string,
        userId: string,
        technicianId: number,
        cancelToken?: CancelToken,
    ): AxiosPromise<TechnicianDetails | undefined>;
}

export const BASE_URL_TOKEN_JobAssistApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class JobAssistApi implements IJobAssistApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_JobAssistApi) @optional() private readonly baseUrl = '') {}

    /**
     * @description Get comprehensive job assistance battlecard data including customer, location, job, appointment, invoice, equipment, estimates, memberships, service agreements, technician, project, and tag information.
     *
     * @tags Job Assist
     * @name GetBattlecardV3
     * @summary Get Job Assist Battlecard V3 data
     * @request GET:/internal/v1/tenant/{tenantId}/user/{userId}/job-assist/battlecard-v3
     */
    getBattlecardV3(
        tenantId: string,
        userId: string,
        query: GetBattlecardV3Params,
        cancelToken?: CancelToken,
    ): AxiosPromise<BattlecardV3Response | undefined> {
        let url_ = `/internal/v1/tenant/${tenantId}/user/${userId}/job-assist/battlecard-v3`;
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            params: query,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(axios.request<BattlecardV3Response | undefined>(options_));
    }

    /**
     * @description Get technician details by ID
     *
     * @tags Job Assist
     * @name GetTechnician
     * @summary Get Technician details
     * @request GET:/internal/v1/tenant/{tenantId}/user/{userId}/job-assist/technician/{technicianId}
     */
    getTechnician(
        tenantId: string,
        userId: string,
        technicianId: number,
        cancelToken?: CancelToken,
    ): AxiosPromise<TechnicianDetails | undefined> {
        let url_ = `/internal/v1/tenant/${tenantId}/user/${userId}/job-assist/technician/${technicianId}`;
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(axios.request<TechnicianDetails | undefined>(options_));
    }
}

// Response Type Interfaces

export interface JobAssistAddress {
    Street?: string | null;
    Unit?: string | null;
    City?: string | null;
    State?: string | null;
    Zip?: string | null;
    Country?: string | null;
}

export interface TaxZone {
    Id?: number;
    Name?: string | null;
}

export interface CustomerDetails {
    CustomerName?: string | null;
    CustomerAddress?: string | null;
    CustomerPhoneNumber?: string | null;
    CustomerEmail?: string | null;
    CustomerId?: number;
}

export interface CustomerBalance {
    Current?: number;
    ThirtyDays?: number;
    SixtyDays?: number;
    NinetyDays?: number;
    AgingPast90?: number;
}

export interface TechnicianInfo {
    TechnicianId?: number;
    TechnicianName?: string | null;
    TechnicianPhoto?: string | null;
}

export interface AppointmentInfo {
    Id?: number;
    JobId?: number;
    Assignments?: AssignmentInfo[] | null;
    CreatedOn?: string;
    ModifiedOn?: string;
    Status?: string | null;
    JobType?: string | null;
    StartDate?: string;
    Technicians?: TechnicianInfo[] | null;
    Number?: string | null;
    JobNumber?: string | null;
    SpecialInstructions?: string | null;
    EndDate?: string;
    Confirmed?: boolean | null;
    TechnicianIds?: number[] | null;
    PlannedStart?: string | null;
    PlannedEnd?: string | null;
    CustomerId?: number;
    CustomerName?: string | null;
    LocationId?: number;
    LocationName?: string | null;
    LocationAddress?: string | null;
    JobSummary?: string | null;
    Duration?: string | null;
    InstalledEquipement?: any | null;
    TotalAppointments?: number;
}

export interface AssignmentInfo {
    AppointmentId?: number;
    Id?: number;
    TechnicianId?: number;
    TechnicianName?: string | null;
    Status?: string | null;
    IsPaused?: boolean;
}

export interface CustomerSummary {
    LifetimeRevenue?: number | null;
    Balance?: CustomerBalance;
    ActiveLocationsCount?: number;
    ActiveMembershipsCount?: number;
    ActiveServiceAgreementsCount?: number;
    OpenEstimatesCount?: number;
    LastCompletedJobNumber?: string | null;
    NextScheduledJobNumber?: string | null;
    MostRecentJobAppointments?: AppointmentInfo[] | null;
    NextScheduledJobAppointments?: AppointmentInfo[] | null;
    MostFrequentTechnician?: TechnicianInfo | null;
    MostFrequentServiceInvoiceItem?: any | null;
    MostFrequentMaterialInvoiceItem?: any | null;
}

export interface ContactInfo {
    Id?: number;
    Type?: string | null;
    Value?: string | null;
}

export interface LocationInfo {
    Id?: number;
    Name?: string | null;
    Address?: JobAssistAddress | null;
    InvoiceSignatureRequired?: boolean;
    LastAppointmentDate?: string | null;
    Tags?: any[] | null;
}

export interface CustomerInfo {
    Details?: CustomerDetails | null;
    Summary?: CustomerSummary | null;
    Contacts?: ContactInfo[] | null;
    Locations?: LocationInfo[] | null;
    Notes?: any[] | null;
}

export interface LocationForJob {
    Id?: number;
    Name?: string | null;
    CustomerName?: string | null;
    Address?: string | null;
    PhoneNumber?: string | null;
    Email?: string | null;
}

export interface LocationsInfoSummary {
    InstalledEquipmentCount?: number;
    CompletedJobCount?: number;
    ActiveMembershipsCount?: number;
    ActiveServiceAgreementsCount?: number;
    OpenEstimatesCount?: number;
    LastCompletedJobNumber?: string | null;
    MostRecentCompletedJobAppointments?: AppointmentInfo[] | null;
    NextScheduledJobNumber?: string | null;
    NextScheduledJobAppointments?: AppointmentInfo[] | null;
    TotalJobs?: number;
    MostFrequentTechnician?: TechnicianInfo | null;
    MostFrequentServiceInvoiceItem?: any | null;
    MostFrequentMaterialInvoiceItem?: any | null;
}

export interface LocationInfoResponse {
    LocationForJob?: LocationForJob | null;
    LocationsInfoSummary?: LocationsInfoSummary | null;
    Contacts?: ContactInfo[] | null;
    RecurringServices?: any[] | null;
    Notes?: any[] | null;
}

export interface ArrivalWindow {
    PlannedStart?: string | null;
    PlannedEnd?: string | null;
}

export interface LeadInfo {
    GeneratedFromId?: number | null;
    CreatedFromEstimateId?: number | null;
    GeneratedFromBusinessUnitId?: number | null;
    GeneratedFromTypeId?: number | null;
}

export interface JobDetails {
    Id?: number;
    TypeName?: string | null;
    Customer?: CustomerDetails | null;
    Location?: LocationForJob | null;
    Summary?: string | null;
    Status?: string | null;
    StartDate?: string | null;
    CompletedDate?: string | null;
    BusinessUnitId?: number;
    CustomerId?: number;
    CustomerName?: string | null;
    InvoiceId?: number;
    JobCustomerLocation?: any | null;
    Name?: string | null;
    LocationId?: number;
    ProjectId?: number | null;
    AssignedTechnicians?: string[] | null;
    AppointmentNumber?: string | null;
    AppointmentStartTime?: string | null;
    Number?: string | null;
    Tasks?: any | null;
    Duration?: string | null;
    ArrivalWindow?: ArrivalWindow | null;
    Billing?: any | null;
    LeadInfo?: LeadInfo | null;
    Total?: number;
}

export interface JobHistoryStats {
    CompletedLastMonthCount?: number;
    CompletedLastTwelveMonthsCount?: number;
    CompletedOverLifetimeCount?: number;
    ScheduledJobsForFuture?: number;
    MostRecent?: JobDetails[] | null;
    NextUpcoming?: JobDetails[] | null;
    Count?: number;
    MostRecentCompletedJobs?: JobDetails[] | null;
    CompletedTotalSum?: number;
    ScheduledTotalSum?: number;
}

export interface JobSummary {
    JobAppointmentsTotalCount?: number;
    JobHistoryStatsForCustomer?: JobHistoryStats | null;
    JobHistoryStatsForLocation?: JobHistoryStats | null;
}

export interface JobHistoryItem {
    Type?: string | null;
    CreatedOn?: string;
    Photo?: string | null;
}

export interface ModifiedBy {
    Id?: number;
    Name?: string | null;
}

export interface JobNote {
    Id?: number;
    Text?: string | null;
    IsPinned?: boolean;
    CreatedOn?: string;
    CreatedBy?: string | null;
    ModifiedOn?: string;
    ModifiedBy?: ModifiedBy | null;
    Archived?: boolean;
    Active?: boolean;
}

export interface JobInfo {
    Details?: JobDetails | null;
    Summary?: JobSummary | null;
    CurrentJobHistory?: JobHistoryItem[] | null;
    CurrentJobAppointments?: any[] | null;
    Notes?: JobNote[] | null;
}

export interface AppointmentsSummary {
    AppointmentsForCurrentJobCount?: number;
    AppointmentsCompletedCount?: number;
    AppointmentsUpcomingCount?: number;
}

export interface AppointmentInfoResponse {
    AppointmentsForJob?: AppointmentInfo[] | null;
    AppointmentsSummary?: AppointmentsSummary | null;
    AppointmentsByCustomer?: AppointmentInfo[] | null;
    AppointmentsByLocation?: AppointmentInfo[] | null;
    AppointmentsCompleted?: AppointmentInfo[] | null;
    AppointmentsUpcoming?: AppointmentInfo[] | null;
    AppointmentsRemaining?: AppointmentInfo[] | null;
    AppointmentsForAssignedTechnician?: AppointmentInfo[] | null;
}

export interface CallsSummary {
    CallsForCustomerCount?: number;
    CallsForLocationCount?: number;
}

export interface CallsInfo {
    CallDetailsLatest?: any | null;
    CallsSummary?: CallsSummary | null;
    CallsHistoryByCustomer?: any[] | null;
    CallsHistoryByLocation?: any[] | null;
}

export interface BusinessUnit {
    Id?: number;
    Name?: string | null;
}

export interface JobType {
    Id?: number;
    Name?: string | null;
}

export interface Job {
    Id?: number;
    ExternalId?: string | null;
    Number?: string | null;
    Summary?: string | null;
    Status?: number;
    CompletedOn?: string | null;
    BusinessUnit?: BusinessUnit | null;
    JobType?: JobType | null;
    ModifiedOn?: string;
    CustomerPo?: string | null;
    CustomerId?: number;
    CustomerName?: string | null;
    InvoiceId?: number;
    Location?: any | null;
    ProjectId?: number | null;
}

export interface InvoiceCustomer {
    ModifiedOn?: string;
    Id?: number;
    Name?: string | null;
}

export interface Location {
    Id?: number;
    CustomerId?: number;
    Name?: string | null;
    ModifiedOn?: string;
    Address?: JobAssistAddress | null;
    TaxZone?: TaxZone | null;
}

export interface CreatedBy {
    Id?: number;
    Name?: string | null;
    ModifiedOn?: string;
}

export interface InvoiceDetails {
    Id?: number;
    Summary?: string | null;
    InvoicedOn?: string | null;
    BusinessUnit?: string | null;
    CustomerBalance?: number;
    DueDate?: string | null;
    Equipment?: any[] | null;
    JobId?: number;
    LocationId?: number;
    Materials?: any[] | null;
    MemberShipId?: number;
    Tasks?: any[] | null;
    PaidStatus?: string | null;
    Subtotal?: number;
    Balance?: number;
    Total?: number;
    Number?: string | null;
    Status?: string | null;
    InvoiceConfiguration?: string | null;
    CreatedOn?: string;
    Items?: any | null;
    CreatedBy?: CreatedBy | null;
    Job?: Job | null;
    Project?: any | null;
    AssignedTo?: any | null;
    Customer?: InvoiceCustomer | null;
    Location?: Location | null;
    CustomerAddress?: JobAssistAddress | null;
    JobNumber?: string | null;
    LaborTasks?: any | null;
    Estimates?: any | null;
    Payments?: any | null;
}

export interface InvoiceStats {
    SoldLastMonthCount?: number;
    RevenueLast1MonthTotal?: number;
    SoldLast12MonthsCount?: number;
    RevenueLast12MonthsTotal?: number;
    LifetimeRevenueTotal?: number | null;
    RecentUnpaid?: InvoiceDetails[] | null;
    UnpaidCount?: number | null;
    OutstandingBalanceTotal?: number | null;
    MaximumSpend?: number | null;
    MostExpensiveItem?: any | null;
    MostRecent?: InvoiceDetails | null;
    MostRecentSold?: InvoiceDetails[] | null;
    MostRecentUnpaid?: InvoiceDetails[] | null;
    Count?: number;
    RecentSold?: InvoiceDetails[] | null;
    RecentSoldCount?: number;
}

export interface InvoiceSummary {
    InvoiceStatsForCustomer?: InvoiceStats | null;
    InvoiceStatsForLocation?: InvoiceStats | null;
}

export interface InvoiceInfo {
    Details?: InvoiceDetails | null;
    Summary?: InvoiceSummary | null;
    InvoiceListForCustomer?: InvoiceDetails[] | null;
    InvoiceListForLocation?: InvoiceDetails[] | null;
    InvoiceListForProject?: InvoiceDetails[] | null;
    InvoiceFromSourceJob?: InvoiceDetails | null;
}

export interface EquipmentStats {
    Count?: number;
    Over20YearsOldCount?: number;
    Over10YearsOldCount?: number;
    Over5YearsOldCount?: number;
    Over1YearOldCount?: number;
    InstalledInLast12MonthsCount?: number;
    InstalledByCompanyCount?: number;
    InstalledByCompetitorCount?: number;
}

export interface EquipmentSummary {
    EquipmentStatsForLocation?: EquipmentStats | null;
    EquipmentStatsForJob?: EquipmentStats | null;
}

export interface EquipmentInfo {
    Summary?: EquipmentSummary | null;
    InstalledEquipmentForJob?: any[] | null;
    InstalledEquipmentAtLocation?: any[] | null;
}

export interface EstimateDetails {
    Id?: number;
    Name?: string | null;
    CreatedOn?: string;
    Total?: number;
    Collected?: number;
    Status?: string | null;
    SoldBy?: string | null;
    OpportunityId?: number;
    OpportunityStatus?: string | null;
}

export interface EstimatesStats {
    Count?: number;
    OpenCount?: number;
    SoldCount?: number;
    OpenTotal?: number;
    SoldLast12MonthsCount?: number;
    SoldLast12MonthsTotal?: number;
    SoldLast1MonthCount?: number;
    SoldLast1MonthTotal?: number;
    DismissedCount?: number;
    DismissedTotal?: number;
    MostRecentOpen?: EstimateDetails | null;
    MostRecentSold?: EstimateDetails | null;
    MostRecentDismissed?: EstimateDetails | null;
}

export interface EstimatesInfoSummary {
    EstimatesStatsForLocation?: EstimatesStats | null;
    EstimatesStatsForCustomer?: EstimatesStats | null;
}

export interface EstimatesInfo {
    EstimateForJob?: EstimateDetails | null;
    EstimatesInfoSummary?: EstimatesInfoSummary | null;
    EstimatesForCustomer?: EstimateDetails[] | null;
    EstimatesForLocation?: EstimateDetails[] | null;
}

export interface MembershipStats {
    TotalCount?: number;
    ActiveCount?: number;
}

export interface MembershipInfoSummary {
    MembershipStatsForCustomer?: MembershipStats | null;
    MembershipStatsForLocation?: MembershipStats | null;
}

export interface MembershipsInfo {
    MembershipInfoSummary?: MembershipInfoSummary | null;
    MembershipsByCustomer?: any[] | null;
    MembershipsByCustomerLocation?: any[] | null;
    RecurringServiceEventsForJob?: any[] | null;
}

export interface ServiceAgreementsStats {
    TotalCount?: number;
    ActiveCount?: number;
}

export interface ServiceAgreementsInfoSummary {
    ServiceAgreementsStatsForCustomer?: ServiceAgreementsStats | null;
    ServiceAgreementsStatsForLocation?: ServiceAgreementsStats | null;
}

export interface ServiceAgreementsInfo {
    ServiceAgreementsInfoSummary?: ServiceAgreementsInfoSummary | null;
    ServiceAgreementsByCustomer?: any[] | null;
    ServiceAgreementsByLocation?: any[] | null;
}

export interface TechnicianDetails {
    Id?: number;
    Name?: string | null;
    Phone?: string | null;
    Status?: string | null;
    Email?: string | null;
    HourlyRate?: number;
}

export interface TechniciansInfoSummary {
    TechniciansAssignedForJobCount?: number;
}

export interface TechniciansInfo {
    TechniciansInfoSummary?: TechniciansInfoSummary | null;
    JobAssignedTechnicians?: TechnicianDetails[] | null;
    PrimaryJobTechnician?: TechnicianDetails | null;
    CurrentTechnicianDetails?: TechnicianDetails | null;
}

export interface ProjectSummary {
    CompletedJobCount?: number;
    ScheduledJobCount?: number;
    TotalJobs?: number;
}

export interface ProjectInfo {
    JobProject?: any | null;
    ProjectSummary?: ProjectSummary | null;
    ProjectsByCustomer?: any[] | null;
    ProjectsByLocation?: any[] | null;
    ProjectJobIds?: number[] | null;
}

export interface TagInfo {
    Id?: number;
    OwnerId?: number;
    TypeId?: number;
    TypeName?: string | null;
    Memo?: string | null;
    Color?: string | null;
    TextColor?: string | null;
    Code?: string | null;
    Importance?: number | null;
    IsVisibleOnDispatchBoard?: boolean;
    AllowToUseOnTimesheetActivity?: boolean;
    ProjectedValueAdjustment?: number;
}

export interface TagsInfo {
    CustomerTags?: TagInfo[] | null;
    ServiceAgreementTags?: TagInfo[] | null;
    JobTags?: TagInfo[] | null;
    MembershipTags?: TagInfo[] | null;
    LocationTags?: TagInfo[] | null;
}

export interface BattlecardV3Response {
    CustomerInfo?: CustomerInfo | null;
    LocationInfo?: LocationInfoResponse | null;
    JobInfo?: JobInfo | null;
    AppointmentInfo?: AppointmentInfoResponse | null;
    CallsInfo?: CallsInfo | null;
    InvoiceInfo?: InvoiceInfo | null;
    EquipmentInfo?: EquipmentInfo | null;
    EstimatesInfo?: EstimatesInfo | null;
    MembershipsInfo?: MembershipsInfo | null;
    ServiceAgreementsInfo?: ServiceAgreementsInfo | null;
    TechniciansInfo?: TechniciansInfo | null;
    ProjectInfo?: ProjectInfo | null;
    TagsInfo?: TagsInfo | null;
}

// Parameter interfaces
export interface GetBattlecardV3Params {
    /** @format int64 */
    jobId: number;
    /** @format int32 */
    limit?: number;
    /** @format int32 */
    threadpoolLimit?: number;
    /** @format int32 */
    pagesize?: number;
    sessionId?: string;
    traceId?: string;
}
